import { useEffect, useState } from 'react';
import APIS from '../../constant/EndPoint';
import useGetHook from '../../customHooks/useGetHook';
import { classNames } from '../../utils/classNames';
import Card from '../Reusable/Card';
//@ts-ignore
import { tw } from '@careinfo/tailwind';

const GridCard = (props: any) => {
  const { item, onClick, props: filterPrams, activeCard } = props;
  const {
    data: gridDataInfo,
    isLoading,
    isRefetching,
  } = useGetHook({
    queryKey: [
      'merchant-overview',
      `${item?.slug}-${JSON.stringify(filterPrams)}-${JSON.stringify(
        item?.slug
      )}`,
    ],
    url: `${item?.service_endpoint}`,
    params: {
      slug: item?.slug,
      delivery_status__in: item?.status.map((x) => x.id).join(','),
      ...filterPrams,
    },
  });

  return (
    <Card
      onClick={() => {
        {
          item?.name === activeCard
            ? onClick('')
            : onClick(item?.status.map((x) => x.id).join(','), item?.name);
        }
      }}
    >
      <div
        className={classNames(
          item?.name === activeCard ? tw`bg-primary-active text-primary` : tw``,
          tw`rounded-md h-full flex flex-col justify-between`
        )}
      >
        <div
          className={tw`uppercase text-primary  font-semibold cursor-pointer mx-2 pt-2`}
        >
          {item?.name}
        </div>
        {isLoading || isRefetching ? (
          <div
            className={tw`flex justify-between mx-3 mt-6 pb-2  animate-pulse`}
          >
            <div className={tw`w-10 bg-gray-300 rounded-lg h-3 `}></div>
            <div className={tw`w-20 bg-gray-300 rounded-lg h-3 `}></div>
          </div>
        ) : (
          <div className={tw`flex flex-wrap justify-between mx-3 mt-4  `}>
            <p className={tw`font-medium text-lg`}>{gridDataInfo?.count}</p>
            <p className={tw`font-medium text-lg`}>Rs.{gridDataInfo?.amount}</p>
          </div>
        )}
      </div>
    </Card>
  );
};

export default GridCard;
